/* eslint-disable */
'use client';
import { Cart } from '../../../interface/checkoutInterface';
import { RawEvent } from '../../../interface/eventInterface';
import { Tracker } from '../trackers';
import { initializeTriplePixel, triggerTripleEvent } from './triplePixel';

export class TripleWhaleTracker implements Tracker {
  private shopId: string;

  constructor(shopId: string) {
    this.shopId = shopId;
  }

  Init(): void {
    this.initializePixels(this.shopId);
  }

  TrackEvent(event: RawEvent): void {
    const { eventName, cart, eventId } = event;
    if (event.eventName == 'Purchase') {
      const cart: Cart | undefined = event?.cart;
      if (cart) {
        initializeTriplePixel(event.shopId, cart.Email);
      }
    }
    if (['q4yxy8-cg', '9ff43a-25'].includes(event?.shopId)) {
      if (eventName == 'Purchase' && cart) {
        triggerTripleEvent('purchase', {
          eventId: eventId,
          email: cart.Email,
          phone: cart.PhoneNumber,
          firstName: cart.ShippingAddress?.FirstName || '',
          lastName: cart.ShippingAddress?.LastName || '',
          orderId: event.orderId || '',
          lineItems: cart.LineItems.map(item => ({
            product_id: item.ProductID ? item.ProductID.toString() : '',
          })),
          address: {
            zip: cart.ShippingAddress?.Zip || '',
            city: cart.ShippingAddress?.City || '',
            countryCode: cart.ShippingAddress?.CountryCode || '',
            provinceCode: cart.ShippingAddress?.ProvinceCode || '',
          },
        });
      } else if (eventName === 'InitiateCheckout') {
        triggerTripleEvent('CheckoutStarted', {
          lineItems: cart?.LineItems?.map(item => ({
            product_id: item?.ProductID ? item?.ProductID?.toString() : '',
          })),
          eventId: eventId,
        });
      } else if (eventName === 'AddPaymentInfo') {
        triggerTripleEvent('PaymentSubmitted', {
          eventId: eventId,
          email: cart?.Email,
          phone: cart?.PhoneNumber,
          firstName: cart?.ShippingAddress?.FirstName || '',
          lastName: cart?.ShippingAddress?.LastName || '',
          order_id: event.orderId || '',
          lineItems: cart?.LineItems.map(item => ({
            product_id: item.ProductID ? item.ProductID.toString() : '',
          })),
          address: {
            zip: cart?.ShippingAddress?.Zip || '',
            city: cart?.ShippingAddress?.City || '',
            countryCode: cart?.ShippingAddress?.CountryCode || '',
            provinceCode: cart?.ShippingAddress?.ProvinceCode || '',
          },
        });
      } else {
        console.info(`Triple Whale: ${eventName} not handled.`);
      }
    }
  }

  private initializePixels(shopId: string): void {
    initializeTriplePixel(shopId);
  }
}
